<div class="qr__container">
  <div class="qr__frame" [class.is-frame-animating]="animate">
    <div class="qr__svg-wrapper" [class.is-svg-wrapper-animating]="animate">
      <div class="qr__code" [innerHTML]="qrCodeSvg"></div>
    </div>
  </div>
</div>